// extracted by mini-css-extract-plugin
module.exports = {"content":"ChangeDelivery_content__qw8qg"};